export default {
  global: {
    colors: {
      brand: '#70A6FF',
    },
    font: {
      family: 'Roboto',
      size: '18px',
      height: '20px',
    },
  },
}
